import { gql } from '@apollo/client';

export const activityFragment = gql`
  fragment Activity on Activity {
    id
    name
    statement
    deadline
    expired
    answerFileSizeLimit
    answered

    createdBy {
      id
      name
    }
  }
`;

export const activityAnswerFragment = gql`
  fragment ActivityAnswer on ActivityAnswer {
    id
    score
    gradedAt
    graded
    createdAt
    gradedBy
    text
    file {
      name
      url
    }
    feedback {
      text
      file {
        name
        url
      }
      createdBy
      createdAt
    }
  }
`;
